import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";
import { createPaymentlinkPoints } from '../../../actions/PasarelaActions';
import { seeWineries } from '../../../admin/actions/wineryActions';
import TitleImg from '../../../utils/components/TitleImg/TitleImg';
import marketplaceBag from '../../../assets/img//MarketplaceBag.png';
import useMercadoPago from '../../../utils/hooks/useMercadoPago';
import { useTokenCallback } from '../../../utils/hooks/useTokenCallback';
import PaymentSummary from '../../ShopingBag/PaymentSummary';
import PoinsItem from '../PoinsItem/PoinsItem';
import "./ShopingBag.css"

const ShopingBagPoins = ({ bag }) => {
    const dispatch = useDispatch()
    const { userInfo } = useSelector(state => state.userInfo)
    const { wineriesList } = useSelector(state => state.wineriesAdmin)
    useTokenCallback(() => {
        dispatch(seeWineries())
    }, [])
    const history = useHistory()
    const mp = useMercadoPago()

    const disscount = 0.9;
    const typeUser = "ecotienda"
    const calculateSubTotal = (bag) => {
        let total = 0
        bag.map(product => {
            total = total + (product.quantity * product.unit_price)
        })
        return total
    }
    const calculateTotal = (value) => {
        if (typeUser) {
            return value * disscount
        } else {
            return value;
        }
    }
    const calculateTotalPoints = (bag) => {
        let total = 0
        bag.map(product => {
            total = total + (product.quantity * product.pointsQuantity)
        })
        return total
    }
    const pay = () => {
        dispatch(createPaymentlinkPoints(
            bag, userInfo.franchiseID._id,
            mp, history))
    }
    return (
        <div>
            <TitleImg img={marketplaceBag} height={64} titleHighlight={"EcoBolsa"} />
            <div className='shoping-bag-container'>
                <div className='list-products-bag scroll-menu'>
                    {bag.map(item => (
                        <PoinsItem item={item} />
                    ))}
                </div>
                <PaymentSummary
                    subTotal={calculateSubTotal(bag)}
                    total={calculateTotal(calculateSubTotal(bag))}
                    totalPoints={calculateTotalPoints(bag)}
                    pay={pay}
                    isPoints={true}
                />
            </div>
        </div>
    )
};

export default ShopingBagPoins;
